import { render, staticRenderFns } from "./TableWidgetUpdated.vue?vue&type=template&id=467d386f"
import script from "./TableWidgetUpdated.vue?vue&type=script&lang=js"
export * from "./TableWidgetUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports